export class RehearsalSceneItemRequestDTO {
    public id: number = 0;
    public required: boolean = false;

}
